import {
    omit,
} from 'lodash'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    FormPart,
} from 'app/types/form.types'
import useValidation from 'app/hooks/useValidation/useValidation'
import Button from 'app/shared-components/Button'

import {
    UpdateFormClassNames,
    UpdateFormData,
} from '../../SimpleBulkUpload.types'
import useStyles from './DataUpdateForm.styles'

type Props = {
    formFields: FormPart<keyof (UpdateFormData)>[]
    onSubmit: (data: Record<string, any>) => void,
    onCancel: () => void,
    onFormChange: (data: UpdateFormData) => void,
    formValue: UpdateFormData,
    classNames?: UpdateFormClassNames
}

const DataUpdateForm = ({
    formFields,
    onSubmit,
    onCancel,
    onFormChange,
    formValue,
    classNames = {},
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const {
        isValid,
    } = useValidation({
        fields: formFields,
        values: formValue,
    })

    const handleUpdate = () => {
        onSubmit(omit(formValue, ['selectedRecords']))
    }

    return (
        <div>
            <DomainObjectForm
                onChange={onFormChange}
                value={formValue}
                fields={formFields}
                wrapper="noCard"
                classNames={{
                    gridCardWrapper: classNames.gridCardWrapper,
                }}
            />
            <div className={classes.buttonsContainer}>
                <Button
                    label="Update"
                    onClick={handleUpdate}
                    disabled={formValue?.selectedRecords === 0 || !isValid}
                />
                <Button
                    label="Cancel"
                    secondary
                    onClick={onCancel}
                />
            </div>
        </div>
    )
}

export default DataUpdateForm
